import React from 'react';
import styles from './BackArrow.module.scss';
import { ReactComponent as BackArrowSVG } from '../../../assets/back-arrow.svg';
import { useNavigate } from 'react-router-dom';

export const BackArrow = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div
                className={styles.row}
                onClick={() => {
                    navigate('/');
                }}
            >
                <BackArrowSVG />
                <div className={styles.text}>Back to Profile</div>
            </div>
        </div>
    );
};
